import type { TOC } from '@ember/component/template-only';

import WizardMetricsComponent from 'webapp/components/wizard/metrics';

const WizardMetricsRouteTemplate: TOC<object> = <template><WizardMetricsComponent /></template>;

export default WizardMetricsRouteTemplate;
